module.exports = __webpack_public_path__ + "clickup-integration-3-ae1aa18f1fc415c4b2af7167a2812ca1.webp";